import Config from '../../config.json';

function getFqdn(): string {
  return window.location.hostname;
}

function removeFirstSubdomainPrefix(partialFqdn: string): string {
  const regex: RegExp = /^[a-z\d]+-/;

  if (regex.test(partialFqdn)) {
    partialFqdn = partialFqdn.split('-')[1];
  }

  return partialFqdn;
}

export function getApiServerUrl(): string {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  } else if (
    Config.REACT_APP_API_URL &&
    Config.REACT_APP_API_URL !== 'ENV_'.concat('API_URL')
  ) {
    return Config.REACT_APP_API_URL;
  } else {
    return `${window.location.protocol}//api-${removeFirstSubdomainPrefix(
      getFqdn()
    )}`;
  }
}

export function getFooterApiServerUrl(): string {
  return getApiServerUrl();
}

export function isApplicationInFederalNetwork(): boolean {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_FEDERAL_NETWORK === 'true';
  } else if (Config.REACT_APP_FEDERAL_NETWORK) {
    return Config.REACT_APP_FEDERAL_NETWORK === 'true';
  }
  return false;
}

export const errorTextOnNotAvailableBundIdConnection = `Es tut uns leid! Ein Versand an das Zentrale Bürgerpostfach ist derzeit nicht möglich,
da die Lösung der FITKO (Föderale IT-Kooperation) für den Betrieb außerhalb des Netz des Bundes / Verbindungsnetz des Bundes noch nicht für den Produktivbetrieb veröffentlicht wurde. Sobald diese Lösung für uns nutzbar ist,
wird sie zeitnah implementiert. Wir bitten um Verständnis!`;

export function getKeycloakClientId(): string {
  return 'behoerdenclient-client';
}
export function getKeycloakRealm(): string {
  return `beh-${getMandant()}`;
}

export function getKeycloakUrl(): string {
  return process.env.REACT_APP_KEYCLOAK_URL || Config.REACT_APP_KEYCLOAK_URL;
}

export function getMandant(): string {
  return window.location.pathname.substring(1).split('/')[0];
}
